module.exports = __webpack_public_path__ + "static/img/Macdonald.dd9492d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Macdonald.jpg
// module id = 9ul7
// module chunks = 0